import { Graph } from "../../graph/lib/graph";
import { Node } from "../../graph/lib/node";
import { Edge } from "../../graph/lib/edge";
import { TreeNode } from "../lib/tree-node";
import { WordTreeNode } from "../wordTree/word-tree-node";
import { MultiSetTreeNode } from "../MultiSet/multi-set-tree-node";

/**
 * This graph is used for the filling tree-nodes exercise.
 * We display the missing nodes randomly on a seperate canvas.
 * To use this class you need to return the answer possibilites and 
 * a reference to an empty canvas.
 */
export class MultipleChoiceGraph extends Graph {

    protected selectedNode: Node = null;

    constructor(canvas: HTMLCanvasElement, possibilities: Node[]) {
        super(canvas, 2, Math.max(possibilities.length * 2 + 2, 12))

        possibilities = this.shuffle(possibilities);
        for (let i = 0; i < possibilities.length; i++) {
            let node = possibilities[i];
            let copy = node.clone();

            if (copy instanceof WordTreeNode) {
                copy.setFixedSize(true);
            }

            if (copy instanceof MultiSetTreeNode) {
                copy.setNoBox(true);
            }

            copy.changeCoordinates(0.5, 2 * i + 1);
            this.nodes.push(copy);
        }
    }

    isSolved():boolean{
        return this.nodes.length == 0;
    }

    shuffle(a: Node[]): Node[] {
        for (let i = a.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [a[i], a[j]] = [a[j], a[i]];
        }
        return a;
    }

    getSelectedNode(): Node {
        return this.selectedNode;
    }

    removeNode(node: Node) {
        if (this.nodes.includes(node)) {
            let index = this.nodes.indexOf(node);
            this.nodes.splice(index, 1);
        }
        this.update();
    }

    resetSelectedNode() {
        if (this.selectedNode != null) {
            if (this.selectedNode instanceof TreeNode) {
                this.selectedNode.resetColor();
                this.selectedNode = null;
            }
            if(this.selectedNode instanceof MultiSetTreeNode){
                this.selectedNode.resetColor();
                this.selectedNode = null;
            }
        }
        this.update();
    }


    keyboardEvent(e: KeyboardEvent) {
        return;
    }

    rightClick(row: number, col: number, node: Node, e: MouseEvent) {
        return;
    }

    leftClick(row: number, col: number, n: Node, e: MouseEvent) {
        let treeNode: TreeNode = null;
        this.nodes.forEach(node => {
            if (node.inParameter(e, this.grid)) {
                if (node instanceof TreeNode) {
                    this.leftClickTreeNode(node);
                    return;
                }
                if (node instanceof MultiSetTreeNode) {
                    this.leftClickMultiSetTreeNode(node);
                    return;
                }
            }
        })


        this.update();
    }

    private leftClickTreeNode(treeNode: TreeNode) {
        if (treeNode == null) {
            return;
        }

        if (this.selectedNode == null) {
            this.selectedNode = treeNode;
            treeNode.selected();
        }
        else {
            if (this.selectedNode instanceof TreeNode) {
                let cur: TreeNode = <TreeNode>this.selectedNode;
                cur.resetColor();
            }
            if (this.selectedNode != treeNode) {
                this.selectedNode = treeNode;
                treeNode.selected();
            } else {
                this.selectedNode = null;
            }

        }

    }

    private leftClickMultiSetTreeNode(node: MultiSetTreeNode) {
        if (node == null)
            return;

        if (this.selectedNode != null) {
            if (this.selectedNode instanceof MultiSetTreeNode) {
                this.selectedNode.resetColor();

                if (this.selectedNode == node) {
                    this.selectedNode = null;
                    return;
                }

            }
        }
        
        this.selectedNode = node;
        node.selected();


    }

    doubleClick(row: number, col: number, node: Node, e: MouseEvent) {
        return;
    }

    existsEdge(fromNode: Node, toNode: Node): boolean {
        return false;
    }

    deleteEdge(fromNode: Node, toNode: Node) {
        return;
    }


    getEdge(fromNode: Node, toNode: Node): Edge {
        return null;
    }

    addEdge(from: Node, to: Node) {
        return;
    }
}
